import { Skeleton } from "@bednbody/ui/components/skeleton";
import { cn } from "@bednbody/ui/lib/utils";

export interface PageLoadingProps {
  label?: string;
  className?: string;
}

/** Small structural placeholder, with no image, timer, or extra animation dependency. */
export function PageLoading({ label = "Loading page...", className }: PageLoadingProps) {
  return (
    <div className={cn("flex min-h-48 w-full min-w-0 items-center justify-center p-6", className)} role="status">
      <span className="sr-only">{label}</span>
      <div aria-hidden className="flex w-full max-w-sm flex-col gap-4">
        <Skeleton className="h-5 w-1/3 motion-reduce:animate-none" />
        <div className="flex flex-col gap-3">
          <Skeleton className="h-3 w-full motion-reduce:animate-none" />
          <Skeleton className="h-3 w-5/6 motion-reduce:animate-none" />
          <Skeleton className="h-3 w-2/3 motion-reduce:animate-none" />
        </div>
      </div>
    </div>
  );
}
